import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

import { CircularProgress } from '@material-ui/core'

import SocketEventHandler from '../Common/SocketEventHandler'

import ConversationHeader from './ConversationHeader'
import UserMessage from '../Dashboard/Dialogue/UserMessage'
import BotMessage from '../Dashboard/Dialogue/BotMessage'
import AnswerPanel from './AnswerPanel'

import {
    getConversation,
    createMessage,
    handleUserNewMessage,
    getStatuses,
} from './actions'

import errorCodes from './errorCodes'

import './index.scss'

const CHANNELS = [
    {
        Id: '*',
        Name: 'All',
    },
    {
        Id: 'email',
        Name: 'Email',
    },
    {
        Id: 'sms',
        Name: 'SMS',
    },
]

class Conversation extends React.Component {
    constructor(props) {
        super(props)

        document.title = 'Conversation Viewer - Impel'
        this.state = {
            selectedChannel: CHANNELS[0],
        }
        this.handleOnSend = this.handleOnSend.bind(this)
        this.historyRef = React.createRef()
    }

    componentDidMount() {
        const { conversationParams } = this.props

        if (!conversationParams) {
            return
        }

        this.props.getConversation(
            conversationParams.id,
            this.state.selectedChannel.Id
        )
    }

    componentDidUpdate(oldProps, oldState) {
        const { selectedChannel: selectedChannelOld } = oldState
        const { selectedChannel } = this.state
        if (selectedChannel.Id !== selectedChannelOld.Id) {
            const { conversationParams } = this.props

            if (!conversationParams) {
                return
            }

            this.props.getConversation(
                conversationParams.id,
                selectedChannel.Id
            )
        }

        const { conversation, token } = oldProps
        const {
            conversation: newConversation,
            token: newToken,
            conversationParams,
        } = this.props

        if (JSON.stringify(conversation) !== JSON.stringify(newConversation)) {
            setTimeout(() => {
                const element = this.historyRef.current

                if (element) {
                    element.scrollTo(0, element.scrollHeight)
                }
            }, 100)
        }

        if (JSON.stringify(conversation) !== JSON.stringify(newConversation)) {
            if (newConversation && newConversation[0]) {
                this.props.getStatuses(
                    newConversation[0].AccountId,
                    conversationParams.id
                )
            }
        }

        if (!token && newToken) {
            this.connectToSocket(newToken)
        }
    }

    connectToSocket(token) {
        const socketOptions = {
            forceNew: true,
            transportOptions: {
                polling: { extraHeaders: { 'Platform-Token': token } },
            },
        }

        // eslint-disable-next-line no-unused-vars
        const seh = new SocketEventHandler(socketOptions, (event, data) => {
            if (event === 'message-receive') {
                this.handleOnNewUserMessageReceive(data)
            }
        })
    }

    handleOnNewUserMessageReceive(data) {
        const { conversationParams } = this.props
        const { id } = conversationParams
        console.log('RECEIVEDMSGHANDLEUSERMESSAGERECEIVE:', data)
        // cloudwatch
        // const authorization = localStorage.getItem(
        //     'pulsarBotPlatform_operatorToken'
        // )
        // axios({
        //     method: 'POST',
        //     url: '/api/operators/logs',
        //     headers: { authorization },
        //     data: {
        //         data: { data },
        //     action: `SocketEventHandler in /Conversation component | Comparing id and data.ConversationId which is ${
        //             id === data.ConversationId
        //         }`,
        //         source: 'CLIENT',
        //         time: new Date().toString(),
        //     },
        // }).catch(error => console.log('Cloudwatch error'))

        if (id === data.ConversationId) {
            this.props.handleUserNewMessage(data)
        }
    }

    handleOnSend(data) {
        const { conversationParams, token } = this.props
        const payload = {
            ...data,
            id: conversationParams.id,
            selectedChannel: this.state.selectedChannel.Id,
        }

        this.props.createMessage(payload, token)
    }

    render() {
        const { selectedChannel } = this.state
        const {
            loading, conversation, error, sendingProgress, unsubscribed
        } = this.props
        const conversationExists = Boolean(
            !loading && conversation && conversation.length
        )
        // const conversationIsEmpty = !loading && conversation && !conversation.length

        let channelFilteredDialog = conversation || []

        if (selectedChannel && selectedChannel.Id !== '*') {
            channelFilteredDialog = channelFilteredDialog.filter(
                item => item.Channel === selectedChannel.Id
            )
        }

        const getSentDate = date => moment.unix(date / 1000).format('MMM DD, YYYY hh:mm A')

        const renderHistory = channelFilteredDialog
            && channelFilteredDialog.map((messageObj, index) => (
                <div key={index}>
                    {messageObj.Initiator === 'human' && (
                        <UserMessage
                            message={messageObj.Message}
                            sent={messageObj.Timestamp}
                            blockClickListener={true}
                            channel={messageObj.Channel}
                            submitIntents={newIntents => console.log(newIntents)}
                            classifierResponse={'{}'}
                            status={messageObj.LeadStatus}
                            isConversation={true}
                            detailsViewable={false}
                            name={messageObj.Name}
                            surname={messageObj.Surname}
                            blacklisted={messageObj.Blacklisted}
                        />
                    )}
                    {messageObj.Initiator === 'bot'
                        && messageObj.MessageStatus !== 'PROCESSING_NOW'
                        && messageObj.CrmAction !== false
                        && !messageObj.IgnoreUpdateFlow && (
                        <BotMessage
                            message={messageObj.Message}
                            sent={messageObj.Timestamp}
                            edited={Boolean(
                                messageObj.EditedBy === 'CRM Salesperson'
                            )}
                            editedBy={
                                messageObj.EditedBy === 'CRM Salesperson'
                                    ? messageObj.EditedBy
                                    : ''
                            }
                            followUp={messageObj.FollowUp}
                            status={messageObj.LeadStatus}
                            apptSet={messageObj.AppointmentData}
                            ignoreUpdate={messageObj.IgnoreUpdateFlow}
                            HTOIgnore={messageObj.HTO}
                            user='B'
                            oldMessage={messageObj.OldMessage}
                            isConversation={true}
                            channel={messageObj.Channel}
                            botName={messageObj.BotName}
                        />
                    )}
                    {messageObj.stopBotEvent === true && (
                        <div className='StopBot__Event'>
                            <p>
                                {messageObj.Action === 'stop'
                                    ? 'Dealer Representative has stopped AI responses for this customer.'
                                    : 'Dealer Representative has re-started AI responses for this customer.'}
                            </p>
                            <span>{getSentDate(messageObj.Timestamp)}</span>
                        </div>
                    )}
                </div>
            ))

        const channelSelector = () => (
            <>
                <p>Channel</p>
                <select
                    onChange={e => {
                        const newChannel = CHANNELS.find(
                            item => item.Id === e.target.value
                        )
                        this.setState({
                            selectedChannel: newChannel,
                        })
                    }}
                >
                    {CHANNELS.map(channel => (
                        <option
                            key={channel.Id}
                            value={channel.Id}
                            selected={
                                channel.Id === this.state.selectedChannel.Id
                            }
                        >
                            {channel.Name}
                        </option>
                    ))}
                </select>
            </>
        )

        console.log(conversation)

        return (
            <div className='ConversationPanel'>
                {loading && (
                    <div className='ConversationPanel__centered'>
                        <CircularProgress />
                    </div>
                )}
                {conversationExists && (
                    <div className='ConversationPanel__wrapper'>
                        <ConversationHeader data={conversation[0]} />
                        <div
                            ref={this.historyRef}
                            style={
                                this.props.conversationParams.viewonly && {
                                    height: '92vh',
                                }
                            }
                            className='ConversationPanel__history scrollable'
                        >
                            {conversationExists && (
                                <div className='ConversationPanel__ChannelSelector'>
                                    {channelSelector()}
                                </div>
                            )}
                            {renderHistory}
                            {/* {this.props.statusOn && this.props.crmStatus && <div className='BotMessage'>
                            <div className='BotMessage__message'>
                                <div className='BotMessage__message__block'>
                                    <p> Status: {this.props.crmStatus.status}</p>
                                    <p> Changed: {this.props.crmStatus.timestamp}</p>
                                </div>
                            </div>
                        </div>} */}
                        </div>
                        {!this.props.conversationParams.viewonly && (
                            <>
                                {!unsubscribed && (
                                    <AnswerPanel
                                        onSend={this.handleOnSend}
                                        sendingProgress={sendingProgress}
                                        conversation={conversation}
                                        selectedChannel={
                                            this.state.selectedChannel.Id
                                        }
                                    />
                                )}
                                {unsubscribed === 1 && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            height: '120px',
                                            justifyContent: 'center',
                                            padding: '20px 0 20px 20px',
                                            borderTop: '1px solid #eee',
                                        }}
                                    >
                                        <span
                                            style={{
                                                color: '#000',
                                                marginTop: '30px',
                                            }}
                                        >
                                            Unfortunately, you cannot reply to
                                            the conversation - The lead has
                                            unsubscribed from the conversation
                                        </span>
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                )}
                {!loading && error && (
                    <div className='ConversationPanel__centered'>
                        <p>{errorCodes[error]}</p>
                    </div>
                )}
            </div>
        )
    }
}

const mapStateToProps = state => {
    const {
        loading,
        token,
        conversation,
        error,
        sendingProgress,
        statusOn,
        crmStatus,
        statuses,
        unsubscribed,
    } = state.conversationPanel
    return {
        loading,
        token,
        conversation,
        error,
        sendingProgress,
        statusOn,
        crmStatus,
        statuses,
        unsubscribed,
    }
}

export default connect(mapStateToProps, {
    getConversation,
    getStatuses,
    createMessage,
    handleUserNewMessage,
})(Conversation)
